import axios from 'axios';

export default {
  namespaced: true,
  state: {

  },
  mutations: {

  },
  actions: {
    addPicWord({ commit }, params) {
      return axios.post('/wxnews/ajax/addPicWord', params).then((data) => {
        return data;
      });
    },
    // 查询图文列表
    queryPicwordList({ commit }, params) {
      return axios.get('/wxnews/ajax/queryPicwordList', {
        params: params,
      }).then((data) => {
        return data;
      });
    },
    // 保存图文消息
    saveArticleReplys({ commit }, params) {
      return axios.post('/wxnews/ajax/saveArticleReplys', params).then((data) => {
        return data;
      });
    },
    delPicWord({ commit }, params) {
      return axios.post('/wxnews/ajax/delPicWord', params).then((data) => {
        return data;
      });
    },
    // 查询自定义图文（包括按title模糊查询）
    queryPicWord({ commit }, params) {
      return axios.get('/wxnews/ajax/queryPicWord', {
        params: params,
      }).then((data) => {
        return data;
      });
    }
  },
};
